import { makeInt } from 'app/utils/ioTs';
import * as iots from 'io-ts';
import { Record } from 'immutable';
import { MAX_DRAW_RESOLUTION } from 'app/models/rtc/draw/constants';

export class Resolution extends Record<{
  width: iots.Int;
  height: iots.Int;
}>({
  width: makeInt(0),
  height: makeInt(0),
}) {}

const coarse = (x: number, accuracy: number) => Math.round(x / accuracy) * accuracy;
/**
 * Calculate resolution for draw input
 *
 * It's going to be `MAX_DRAW_RESOLUTION` on the longer side. Shorter
 * side is proportional to the aspect ratio. This is mostly to
 * avoid huge numbers appear in the payload sent to the server.
 *
 * The resolution is also rounded to the nearest 10, to avoid
 * small changes in the input size making the calculated resolution
 * alternate between two close values.
 */
export const surfaceResolution = (width: number, height: number): Resolution => {
  if (width <= 0 || height <= 0) {
    return new Resolution({
      width: makeInt(0),
      height: makeInt(0),
    });
  }

  const aspectRatio = width / height;

  return new Resolution({
    width: makeInt(Math.min(MAX_DRAW_RESOLUTION, coarse(MAX_DRAW_RESOLUTION * aspectRatio, 10))),
    height: makeInt(Math.min(MAX_DRAW_RESOLUTION, coarse(MAX_DRAW_RESOLUTION / aspectRatio, 10))),
  });
};
